import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { PlayerService } from 'src/app/shared/player.service';
import { User } from 'src/app/shared/user.model';
import { UserService } from 'src/app/shared/user.service';
import { ObjectivesService } from '../../services/objectives.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-new-task-dialog',
    templateUrl: './new-task-dialog.component.html',
    styleUrls: ['./new-task-dialog.component.css'],
    imports: [ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, MatSelect, MatOption, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatDialogActions, MatButton, MatDialogClose]
})
export class NewTaskDialogComponent implements OnInit {

  taskForm;
  users: User[];

  constructor(private fb: UntypedFormBuilder,
    private playerService: PlayerService,
    private objectiveService: ObjectivesService,
    private userService: UserService,
    public dialogRef: MatDialogRef<NewTaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {ObjectiveId: string, Owner: string}) { }

  ngOnInit(): void {

    
    this.taskForm = this.fb.group({
      ObjectiveId: [this.data.ObjectiveId],
      TaskId: [''],
      Owner: [this.data.Owner, [Validators.required]],
      Title: ['',Validators.required],
      Description: [''],      
      TargetDate: ['',Validators.required],

      
    });

    this.userService.getAllUsers().subscribe(data=>{
      this.users =  data as User[];
    });
  }

  onSubmit() {
    // TODO: Use EventEmitter with form value
    /* console.warn(this.taskForm.value);
    console.log(this.taskForm.valid); */
    this.objectiveService.addTask(this.taskForm.value).subscribe(res=>{
      this.dialogRef.close();
    });
  }

}
